module.exports = __webpack_public_path__ + "img/tlaloc.eac9d550.jpg";